import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import FAQ from "../../layouts/FAQ/FAQ";


const FAQPage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <FAQ />
        </>
        
    )
}
export default FAQPage;